<template>
<custom-combobox
  flat
  no-filter
  hide-no-data
  hide-details
  append-icon="mdi-magnify"
  placeholder="Search..."
  :search-input.sync="query"
  :items="items"
  @selection="select"
  @submit="run"
>
  <template #item="{ item }">
    <v-list-item-content>
      <v-list-item-title>
        <span style="color: green">{{ parsed.complete }} </span>
        <span>{{ parsed.correct }} </span>
        <template v-if="parsed.rest.trim()">
          <span
            :style="{color: item.type == 'clear' ? 'red' : ''}"
          >{{ parsed.rest }}</span>
          <template v-if="item.type == 'value'">
             <em style="color: lightgray"> {{ item.prompt }}</em>
           </template>
           <template v-else-if="item.type == 'keyword'">
             <span
               style="color: lightgray"
             >{{ item.prompt.substr(parsed.rest.trim().length) }}</span>
           </template>
        </template>
        <template v-else>
         <span style="color: lightgray">{{ item.prompt }}</span>
        </template>
      </v-list-item-title>
      <v-list-item-subtitle v-if="item.message">
        {{ item.message }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action v-if="item.uiAction">
      <v-list-item-action-text>{{ item.uiAction }}</v-list-item-action-text>
      <v-icon v-if="item.uiIcon">{{ item.uiIcon }}</v-icon>
    </v-list-item-action>
  </template>
  <template #append>
    <year-picker ref="YearPicker" />
    <person-picker ref="PersonPicker" />
    <rating-picker ref="RatingPicker" />
    <user-picker ref="UserPicker" />
    <tag-picker ref="TagPicker" />
    <category-picker ref="CategoryPicker" />
    <filter-picker ref="FilterPicker" />
  </template>
</custom-combobox>
</template>

<script>
import Parser from "@/components/search/parser/Parser"
import CustomCombobox from "@/components/search/CustomCombobox"
import YearPicker from "@/components/search/dialogs/YearPicker"
import PersonPicker from "@/components/search/dialogs/PersonPicker"
import RatingPicker from "@/components/search/dialogs/RatingPicker"
import UserPicker from "@/components/search/dialogs/UserPicker"
import TagPicker from "@/components/search/dialogs/TagPicker"
import CategoryPicker from "@/components/search/dialogs/CategoryPicker"
import FilterPicker from "@/components/search/dialogs/FilterPicker"

const parser = new Parser()

export default {
  name: "SearchBar",
  components: {
    CustomCombobox,
    YearPicker,
    PersonPicker,
    RatingPicker,
    UserPicker,
    TagPicker,
    CategoryPicker,
    FilterPicker,
  },
  data() {
    return {
      query: "",
      parsed: {},
    }
  },
  computed: {
    items() {
      return this.parsed.suggestions || []
    },
  },
  methods: {
    run() {
      if (!this.query) {
        return
      }
      if (this.parsed.query) {
        this.$router.push({
          name: "Films",
          query: {query: btoa(this.parsed.query)}
        })
      } else {
        this.$router.push({name: "Films", query: {text: this.query}})
      }
    },
    select(choice) {
      if (choice.type == "keyword") {
        this.query = this.parsed.complete + " " +
                     this.parsed.correct + " " + choice.prompt + " "
      } else
      if (choice.type == "clear") {
        this.query = this.parsed.complete + " " + this.parsed.correct + " "
      } else
      if (choice.uiAction == "PICKER") {
        const picker = this.$refs[choice.name + "Picker"]
        if (picker) {
          picker.pop()
            .then(value => this.query = this.query.trim() + "  " + value + " ")
        }
      }
    },
  },
  watch: {
    query() {
      this.parsed = parser.parse(this.query || "")
    },
  },
}
</script>
